<template>
  <div>
    <el-dialog
      class="edit-dialog hide-header"
      :title="title"
      ref="ruleForm"
      :visible.sync="dialogFormVisible"
      :close-on-click-modal="false"
      @close="editCallback"
    >
      <div class="content" v-if="customerEdit">
        <div v-for="(condition, i) in conditions" :key="i">
          <div class="con-title">
            <span>{{ condition.title }}</span>
          </div>
          <el-form
            :model="form"
            class="edit-el-form"
            size="small"
            v-if="i == 0"
          >
            <div v-for="item in condition.data" :key="item.name">
              <div v-if="item.readOnly">
                <div class="cont-item">
                  <div class="cont-name">{{ item.label }}</div>
                  <div class="cont-info">
                    {{
                      (item.formatter &&
                        item.formatter(data, null, data[item.name])) ||
                      data[item.name] ||
                      "--"
                    }}
                  </div>
                </div>
              </div>
              <el-form-item
                v-if="!item.readOnly"
                :label="item.label"
                label-width="120px"
                class="v-check"
              >
                <!-- 输入框 -->
                <el-input
                  v-if="item.type == 'input' && item.checkParams"
                  v-model="form[item.name]"
                  :placeholder="item.label"
                  v-checkParams="item.checkParams"
                ></el-input>
                <el-input
                  v-if="item.type == 'input' && !item.checkParams"
                  v-model="form[item.name]"
                  :placeholder="item.label"
                ></el-input>
                <!-- 联想搜索框 -->
                <el-autocomplete
                  v-if="item.type == 'autoInput' && item.checkParams"
                  v-model="form[item.name]"
                  :fetch-suggestions="
                    (queryString, cb) => {
                      return querySearchAsync(queryString, cb, item.queryFn);
                    }
                  "
                  :placeholder="item.label"
                  @select="handleSelect($event, item.relationForm)"
                  :trigger-on-focus="false"
                  v-checkParams="item.checkParams"
                ></el-autocomplete>
                <el-autocomplete
                  v-if="item.type == 'autoInput' && !item.checkParams"
                  v-model="form[item.name]"
                  :fetch-suggestions="
                    (queryString, cb) => {
                      return querySearchAsync(queryString, cb, item.queryFn);
                    }
                  "
                  :placeholder="item.label"
                  @select="handleSelect($event, item.relationForm)"
                  :trigger-on-focus="false"
                ></el-autocomplete>
                <!-- 下拉框 -->
                <el-select
                  v-if="item.type == 'select'"
                  v-model="form[item.name]"
                  :placeholder="item.label"
                  :disabled="item.disabled"
                >
                  <el-option
                    v-for="option in item.options"
                    :key="option.value"
                    :label="option.label"
                    :value="option.value"
                  ></el-option>
                </el-select>
                <!-- 级联下拉框 -->
                <el-cascader
                  ref="cascaderAddr"
                  v-if="item.type == 'cascader'"
                  v-model="form[item.name]"
                  :placeholder="item.label"
                  :props="{ lazy: true, lazyLoad: item.lazyLoad }"
                  @change="handleCascader(item.relationForm)"
                >
                </el-cascader>
                <!-- 开关 -->
                <el-switch
                  v-if="item.type == 'switch'"
                  v-model="form[item.name]"
                ></el-switch>
                <!-- 多选框 -->
                <el-checkbox-group
                  v-if="item.type == 'checkbox'"
                  v-model="form[item.name]"
                >
                  <el-checkbox
                    v-for="checkbox in item.checkboxs"
                    :key="checkbox.label"
                    :label="checkbox.label"
                    name="type"
                  ></el-checkbox>
                </el-checkbox-group>
                <!-- 单选框 -->
                <el-radio-group
                  v-if="item.type == 'radio'"
                  v-model="form[item.name]"
                >
                  <el-radio
                    v-for="radio in item.radios"
                    :key="radio.value"
                    :label="radio.value"
                    >{{ radio.label }}</el-radio
                  >
                </el-radio-group>
              </el-form-item>
            </div>
          </el-form>

          <el-form
            :model="form"
            class="edit-el-form"
            size="small"
            v-show="i !== 0"
            v-for="(x, y) in data1"
            :key="y"
          >
            <div v-for="item in condition.data" :key="item.name">
              <div>
                <div class="cont-item">
                  <div class="cont-name">{{ item.label }}</div>
                  <div class="cont-info">
                    {{
                      (item.formatter &&
                        item.formatter(null, null, x[item.name])) ||
                      x[item.name] ||
                      "--"
                    }}
                  </div>
                </div>
              </div>
            </div>
          </el-form>
        </div>
      </div>

      <div class="content" v-else>
        <div v-for="(condition, i) in conditions" :key="i">
          <div class="con-title">
            <span>{{ condition.title }}</span>
          </div>
          <el-form :model="form" class="edit-el-form" size="small">
            <div v-for="(item, j) in condition.data" :key="j">
              <div v-if="item.readOnly">
                <div v-if="item.type == 'image'" class="cont-item-image">
                  <div class="cont-name">{{ item.label }}</div>
                  <img :class="item.class" :src="form[item.name]" alt="" />
                </div>
                <div class="cont-item" v-else>
                  <div class="cont-name">{{ item.label }}</div>
                  <div class="cont-info">
                    {{
                      (item.formatter &&
                        item.formatter(null, null, data[item.name])) ||
                      data[item.name] ||
                      "--"
                    }}
                  </div>
                </div>
              </div>
              <el-form-item
                v-if="!item.readOnly"
                :label="item.label"
                label-width="120px"
                class="v-check"
              >
                <!-- 输入框 -->
                <el-input
                  v-if="item.type == 'input' && item.checkParams"
                  v-model="form[item.name]"
                  :placeholder="item.label"
                  v-checkParams="item.checkParams"
                  @blur="inputChange(item)"
                ></el-input>
                <el-input
                  v-if="item.type == 'number' && item.checkParams"
                  v-model="form[item.name]"
                  :placeholder="item.label"
                  v-checkParams="item.checkParams"
                  type="number"
                  @blur="inputChange(item)"
                ></el-input>
                <el-input
                  v-if="item.type == 'input' && !item.checkParams"
                  v-model="form[item.name]"
                  :placeholder="item.label"
                ></el-input>
                <!-- 联想搜索框 -->
                <el-autocomplete
                  v-if="item.type == 'autoInput' && item.checkParams"
                  v-model="form[item.name]"
                  :fetch-suggestions="
                    (queryString, cb) => {
                      return querySearchAsync(queryString, cb, item.queryFn);
                    }
                  "
                  :placeholder="item.label"
                  @select="handleSelect($event, item.relationForm)"
                  :trigger-on-focus="false"
                  v-checkParams="item.checkParams"
                ></el-autocomplete>
                <el-autocomplete
                  v-if="item.type == 'autoInput' && !item.checkParams"
                  v-model="form[item.name]"
                  :fetch-suggestions="
                    (queryString, cb) => {
                      return querySearchAsync(queryString, cb, item.queryFn);
                    }
                  "
                  :placeholder="item.label"
                  @select="handleSelect($event, item.relationForm)"
                  :trigger-on-focus="false"
                ></el-autocomplete>
                <!-- 下拉框 -->
                <el-select
                  ref="selection"
                  v-if="item.type == 'select'"
                  v-model="form[item.name]"
                  :placeholder="item.label"
                  :disabled="item.disabled"
                  @change="
                    handleSelectForm($event, item.relationForm, item.options)
                  "
                >
                  <el-option
                    v-for="option in item.options"
                    :key="option.value"
                    :label="option.label"
                    :value="option.value"
                  ></el-option>
                </el-select>
                <!-- 级联下拉框 -->
                <el-cascader
                  ref="cascaderAddr"
                  v-if="item.type == 'cascader'"
                  v-model="form[item.name]"
                  :placeholder="item.label"
                  :props="{ lazy: true, lazyLoad: item.lazyLoad }"
                  @change="handleCascader(item.relationForm)"
                >
                </el-cascader>
                <!-- 开关 -->
                <el-switch
                  v-if="item.type == 'switch'"
                  v-model="form[item.name]"
                ></el-switch>
                <!-- 多选框 -->
                <el-checkbox-group
                  v-if="item.type == 'checkbox'"
                  v-model="form[item.name]"
                >
                  <el-checkbox
                    v-for="checkbox in item.checkboxs"
                    :key="checkbox.value"
                    :label="checkbox.value"
                    name="type"
                    >{{ checkbox.label }}</el-checkbox
                  >
                </el-checkbox-group>
                <!-- 单选框 -->
                <el-radio-group
                  v-if="item.type == 'radio'"
                  v-model="form[item.name]"
                  :disabled="item.disabled"
                >
                  <el-radio
                    v-for="radio in item.radios"
                    :key="radio.value"
                    :label="radio.value"
                    >{{ radio.label }}</el-radio
                  >
                </el-radio-group>
                <!-- 文本域 -->
                <el-input
                  v-if="item.type == 'textarea'"
                  type="textarea"
                  v-model="form[item.name]"
                  :placeholder="
                    item.placeholder ? item.placeholder : item.label
                  "
                ></el-input>
                <!-- 上传文件 -->
                <el-upload
                  v-if="item.type == 'image'"
                  :class="item.class"
                  :action="$server + '/image/addImage'"
                  :show-file-list="false"
                  :headers="{ Authorization: token }"
                  class="upload"
                  :on-success="
                    (response, file, fileList) => {
                      return handleImageSuccess(response, file, fileList, item);
                    }
                  "
                >
                  <img
                    v-if="form[item.name]"
                    :src="form[item.name]"
                    :class="item.class"
                  />
                  <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                </el-upload>
                <!-- 选择日期 -->
                <el-date-picker
                  v-if="item.type == 'date'"
                  v-model="form[item.name]"
                  type="date"
                  value-format="yyyy-MM-dd"
                  :placeholder="item.label"
                >
                </el-date-picker>
              </el-form-item>
            </div>
            <div  v-for="(d, j) in ticketList"
                :key="j">
              <el-form-item
                label="发票编号"
               label-width="120px"
                class="v-check"
              >
                <el-input
                  style="margin-top:10px"
                  v-model="d.receiptNo"
                  placeholder="
                      发票编号
                    "
                ></el-input>

                <el-input
                 style="margin-top:10px"
                  v-model="d.receiptMoney"
                  placeholder="
                      发票金额
                    "
                ></el-input>

<!-- 
                <el-input
                 style="margin-top:10px"
                  v-model="d.receiptTime"
                  placeholder="
                      出票时间
                    "
                ></el-input> -->

                <el-date-picker style="margin-top:10px;text-align:center"  value-format="yyyy-MM-dd" type="date" placeholder="出票日期" v-model="d.receiptTime"></el-date-picker>
                <!-- 上传发票凭证 -->
                <el-upload
                  style="margin-top:10px"
                  :action="$server + '/image/addImage'"
                  :show-file-list="false"
                  :headers="{ Authorization: token }"
                  class="upload idCard"
                  :on-success="
                    (response, file, fileList) => {
                      return handleImageSuccess(response, file, fileList, d, j);
                    }
                  "
                >
                  <img
                    v-if="d.receiptUrl"
                    :src="$preffix + d.receiptUrl"
                    class="idCard"
                  />
                  <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                </el-upload>
              </el-form-item>
              
            </div>
            <el-form-item label="备注">
                <el-input
                  type="textarea"
                  v-model="form.remark"
                  placeholder="备注"
                ></el-input>
              </el-form-item>
          </el-form>
        </div>
      </div>

      <div slot="footer" class="dialog-footer">
        <div v-for="(button, i) in buttons" :key="i" style="margin-left: 10px">
          <el-button
            v-if="!button.checkSubmit"
            :type="button.type"
            size="small"
            @click="editCallback(button)"
            >{{ button.label }}</el-button
          >
          <el-button
            v-if="button.checkSubmit"
            :type="button.type"
            size="small"
            :data-eventKey="button.eventKey"
            v-checkSubmit
            >{{ button.label }}</el-button
          >
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
/**
 * props 参数conditions
 * name:属性key; type分为:input|select|date|switch|checkbox|radio;
 * options:type为select需下拉选项 checkboxs:type为checkbox需多选项 radios:type为radio需单选项
 * 例：{ label: "团队名称", name: "name", type: "input" },
 * props 参数buttons
 * eventKey:通过key在回调中处理按钮事件 type:按钮样式类型 checkSubmit:是否需要绑定提交指令
 * 例：{ label: "确定", eventKey: "submit", type: "primary" ,checkSubmit:true},
 */
export default {
  name: "EditMoreDialog",
  props: {
    conditions: {
      type: Array,
      required: true,
    },
    buttons: {
      type: Array,
      default: () => [
        { label: "取消", eventKey: "cancel" },
        {
          label: "确定",
          eventKey: "submit",
          type: "primary",
          checkSubmit: true,
        },
      ],
    },
    title: {
      type: String,
      default: "编辑弹窗",
    },

    editVisible: {
      type: Boolean,
      required: true,
    },
    customerEdit: {
      type: Boolean,
      default: false,
    },
    data: {
      type: Object,
      default: {},
    },
    data1: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      dialogFormVisible: this.editVisible,
      form: {},
      ticketList: [],
    };
  },
  methods: {
    inputChange(item) {
      console.log("dghsagdjagsjgdjgsjg");
      console.log("this.form.count:", this.form.count);
      console.log("this.ticketList.length:", this.ticketList.length);
      if (item.label == "单据数量") {
        if (this.form.count == this.ticketList.length) {

        } else if (this.form.count > this.ticketList.length&&this.ticketList.length != 0) {
          for (var i = 0; i < this.form.count-this.ticketList.length; i++) {
            this.ticketList.push({ receiptNo: "", receiptUrl: "" ,receiptMoney:"",receiptTime:""});
          }
        } else if (this.form.count < this.ticketList.length) {
          this.ticketList.splice(
            this.ticketList.length - this.form.count,
            this.ticketList.length - this.form.count
          );
        } else if (this.ticketList.length == 0) {
          this.ticketList = [];
          for (var i = 0; i < this.form.count; i++) {
            this.ticketList.push({ receiptNo: "", receiptUrl: "" ,receiptMoney:"",receiptTime:""});
          }
        }else if (this.form.count == 0) {
          this.ticketList = [];
        }
      }
    },
    editCallback(button, valid) {
      console.log("this.ticketList:", this.ticketList);
      if (!button || button.eventKey == "cancel") {
        this.$emit("update:editVisible", false);
        return;
      }
      if (!valid) {
        return;
      }
      this.$emit(
        "editCallback",
        button ? button.eventKey : "cancel",
        { ...this.form, list: this.ticketList },
        valid
      );
    },
    checkSubmit(valid, eventKey) {
      console.log(valid, eventKey);
      this.editCallback({ eventKey }, valid);
    },
    querySearchAsync(queryString, cb, fn) {
      fn(queryString).then((results) => {
        console.log(results);
        cb(results);
      });
    },
    handleImageSuccess(response, file, fileList, item, i) {
      if (response.code == "0") {
        console.log("receiptUrl:", response.data);
        this.$set(this.ticketList, i, {
          ...this.ticketList[i],
          receiptUrl: response.data,
        });
        this.$message.success("上传成功");
        console.log("ticketList:", this.ticketList);
      } else {
        this.$message.error(response.message);
      }
    },
    handleSelect(item, relationForm) {
      console.log(item, relationForm);
      relationForm.forEach((v) => {
        this.$set(this.form, v, item[v]);
      });
    },
    handleSelectForm(e, relationForm, options) {
      console.log(e, relationForm);
      relationForm &&
        relationForm.forEach((v, i) => {
          console.log(v);
          if (v == "imagePath") {
            this.$axios
              .post(
                this.$server + "/brand/brandDetail",
                this.$qs.stringify({
                  id: e,
                })
              )
              .then((res) => {
                console.log(res);
                this.$set(
                  this.form,
                  v,
                  this.$preffix + res.data.data.imagePath
                );
              });

            this.$axios
              .post(
                this.$server + "/company/companyByBrand",
                this.$qs.stringify({
                  brandId: e,
                })
              )
              .then((res) => {
                let arr = res.data.data;
                let allCompanyList = [];
                arr.forEach((v) => {
                  let obj = {};
                  obj.value = v.companyId + "";
                  obj.label = v.companyName;
                  allCompanyList.push(obj);
                });
                this.$set(this.form, "companyId", "");
                this.$set(this.form, "companyName", "");
                this.conditions[0].data[2].options = allCompanyList;
              });
          } else {
            options.forEach((item) => {
              if (item.value == e) {
                console.log(item);
                this.$set(this.form, v, item.label);
              }
            });
          }
        });
    },
    handleCascader(relationForm) {
      this.$nextTick(() => {
        let addr = this.$refs["cascaderAddr"][0].getCheckedNodes()[0]
          .pathLabels;
        console.log(addr);
        console.log(relationForm);
        relationForm.forEach((v, i) => {
          this.$set(this.form, v, addr[i]);
        });
      });
    },
  },
  created() {
    console.log(this.data);
    this.token = window.localStorage.getItem("token");
    this.form = this.$deepClone(this.data);
  },
};
</script>
<style lang='scss' scoped>
.dialog-footer {
  display: flex;
  justify-content: flex-end;
}
.cont-item-image {
  display: flex;
  margin-bottom: 18px;
  .cont-name {
    float: left;
    width: 120px;
    text-align: left;
  }
}
.cont-item {
  height: 40px;
  line-height: 40px;
  margin-bottom: 18px;
  .cont-name {
    float: left;
    width: 120px;
    text-align: left;
  }
  .cont-info {
    float: left;
    text-align: left;
  }
}
.con-title {
  text-align: left;
  margin-bottom: 10px;
  span {
    border-bottom: 2px #409eff solid;
    line-height: 30px;
    padding: 5px 0;
  }
}
</style>
<style >
.edit-dialog.hide-header .el-dialog__header {
  display: none;
}
.el-autocomplete,
.el-cascader,
.el-date-editor.el-input,
.el-date-editor.el-input__inner {
  width: 100%;
}
.el-form-item__content {
  text-align: left;
}
.upload .el-upload {
  border: 1px #ddd dashed;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #def5ff66;
  border-radius: 3px;
}
.upload .el-upload img {
  width: 100%;
  height: 100%;
}
.avatar .el-upload {
  width: 100px;
  height: 100px;
}
.idCard .el-upload {
  width: 280px;
  height: 200px;
}
.imageSize150 .el-upload {
  width: 150px;
  height: 150px;
}
.cont-item-image .imageSize150 {
  width: 150px;
  height: 150px;
}
</style>


// WEBPACK FOOTER //
// src/components/common/page/EditMoreDialog.vue